import { styled } from '@mui/material/styles';
import {
  Autocomplete,
  Backdrop,
  Box,
  Button,
  Grid,
  IconButton,
  SvgIcon,
  Typography,
} from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';
import { lightPalette, up } from '../../../../theme';

export const classes = {
  root: 'root',
  invoiceGridMainBox: 'invoiceGridMainBox',
  invoiceGridInnerBox: 'invoiceGridInnerBox',
  invoicePdfBox: 'invoicePdfBox',
  invoiceGrid: 'invoiceGrid',
  invoiceGridBox: 'invoiceGridBox',
  invoiceRecordBox: 'invoiceRecordBox',
  invoiceRecordTitle: 'invoiceRecordTitle',
  validateBtn: 'validateBtn',
  trashBtn: 'trashBtn',
  checkCircleIcon: 'checkCircleIcon',
  gridContainer: 'gridContainer',
  gridContainerBackgroundColor: 'gridContainerBackgroundColor',
  gridContainerBackgroundHoverColor: 'gridContainerBackgroundHoverColor',
  checkedFieldIcon: 'checkedFieldIcon',
  fiberManualRecordIcon: 'fiberManualRecordIcon',
  contentEditableField: 'contentEditableField',
  typographyField: 'typographyField',
  gridAlign: 'gridAlign',
  checkCloseIcon: 'checkCloseIcon',
  cardComponent: 'CardComponent',
  closeAction: 'closeAction',
  cardHeader: 'cardHeader',
  cardContent: 'CardContent',
  PreviousVersionBox: 'PreviousVersionBox',
  VersionAutoCompleteBox: 'VersionAutoCompleteBox',
  gridItemAutoComplete: 'gridItemAutoComplete',
  gridItems: 'gridItems',
  previousVersion: 'previousVersion',
  ConfirmDocumentCheckCircleIcon: 'ConfirmDocumentCheckCircleIcon',
  gridItemsTypography: 'gridItemsTypography',
  ConfirmDocumentButtonsBox: 'ConfirmDocumentButtonsBox',
  SaveChangesButtons: 'SaveChangesButtons',
  editModeCheckIcon: 'editModeCheckIcon',
  validateCheckIcon: 'validateCheckIcon',
  loaderBox: 'loaderBox',
  cursorDefaultClass: 'cursorDefaultClass',
  cursorDisableClass: 'cursorDisableClass',
  sidebarTypographyColor: 'sidebarTypographyColor',
  noBoundingBoxColor: 'noBoundingBoxColor',
  noBoundingBoxTypography: 'noBoundingBoxTypography',
  dialogBoxClass: 'dialogBoxClass',
  subNavbar: 'subNavbar',
  subNavbarToolbar: 'subNavbarToolbar',
  subNavbarToolbarJustifyContentFlexEnd:
    'subNavbarToolbarJustifyContentFlexEnd',
  subNavbarToolbarJustifyContentConditionalSpaceBetween:
    'subNavbarToolbarJustifyContentConditionalSpaceBetween',
  versionSelect: 'versionSelect',
  selectVersionHelperText: 'selectVersionHelperText',
  annotationLoadingContainer: 'annotationLoadingContainer',
  confirmDocumentButtonContainer: 'confirmDocumentButtonContainer',
  editField: 'editField',
  inputGrid: 'inputGrid',
  datePickerTextField: 'datePickerTextField',
  stagSelectDropdownButton: 'stagSelectDropdownButton',
  arrowDownIconWithTransition: 'arrowDownIconWithTransition',
  arrowDownIconWithoutTransition: 'arrowDownIconWithoutTransition',
  newHeight: 'newHeight',
  invoicePdfBoxNewHeight: 'invoicePdfBoxNewHeight',
  rootGridContainer: 'rootGridContainer',
  invoiceGridNewHeight: 'invoiceGridNewHeight',
  firstRow: 'firstRow',
  moreHeight: 'moreHeight',
  documentEditCellBox: 'documentEditCellBox',
  editCellTextfield: 'editCellTextfield',
  editCellActionIcons: 'editCellActionIcons',
  editIcon: 'editIcon',
  transactinGrid: 'transactinGrid',
  transactionGridSection: 'transactionGridSection',
  deleteButton: 'deleteButton',
  pagination: 'pagination',
  arrowButton: 'arrowButton',
  arrowHoverButton: 'arrowHoverButton',
  blankDiv: 'blankDiv',
};

export const StyledDatePicker = styled(DateTimePicker)(() => ({
  width: '100%',
  marginBottom: '10px',
}));

export const AutoCompleteRenderOptionBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
}));

export const StyledSVGIcon = styled(SvgIcon)(({ theme }) => ({
  stroke: theme.palette.colorGreen.main,
  fill: 'none',
  [up('xs')]: {
    width: '15px',
    height: '15px',
  },
  [up('sm')]: {
    width: '16px',
    height: '16px',
  },
  [up('md')]: {
    width: '15px',
    height: '15px',
  },
  [up('lg')]: {
    width: '16px',
    height: '16px',
  },
  [up('xl')]: {
    width: '17px',
    height: '17px',
  },
  [up('xxl')]: {
    width: '18px',
    height: '18px',
  },
}));

export const StyledSVGCircleIcon = styled(SvgIcon)({
  backgroundColor: '#FFA500',
  borderRadius: '50%',
  [up('xs')]: {
    width: '5px',
    height: '5px',
  },
  [up('sm')]: {
    width: '6px',
    height: '6px',
  },
  [up('md')]: {
    width: '9px',
    height: '9px',
  },
  [up('lg')]: {
    width: '7px',
    height: '7px',
  },
  [up('xl')]: {
    width: '9px',
    height: '9px',
  },
  [up('xxl')]: {
    width: '10px',
    height: '10px',
  },
});

export const SelectCurrencyAutoComplete = styled(Autocomplete)(() => ({
  width: '8vw',
  [up('xs')]: {
    width: '16vw',
  },
  [up('sm')]: {
    width: '14vw',
  },
  [up('md')]: {
    width: '10vw',
  },
  [up('lg')]: {
    width: '8vw',
  },
  [up('xl')]: {
    width: '7vw',
  },
  [up('xxl')]: {
    width: '6.5vw',
  },
}));

export const InputPopupContainer = styled(Box)({
  borderRadius: '5px',
  boxShadow: '0px 0px 11px 4px rgba(0, 0, 0, 0.08)',
  backgroundColor: 'rgba(255, 255, 255, 1)',
  padding: '40px 40px 26px',
  display: 'flex',
  flexDirection: 'column',
  width: '700px',
  // [up('xs')]: {
  //   width: '625px',
  // },
  // [up('sm')]: {
  //   width: '650px',
  // },
  // [up('md')]: {
  //   width: '675px',
  // },
  // [up('lg')]: {
  //   width: '700px',
  // },
  // [up('xl')]: {
  //   width: '725px',
  // },
  // [up('xxl')]: {
  //   width: '750px',
  // },
});
export const CurrencyConverterBoxContainer = styled(Box)({
  display: 'flex',
  gap: '40px',
  marginBottom: '10px',
  alignItems: 'center',
  [up('xs')]: {
    gap: '10px',
  },
  [up('sm')]: {
    gap: '11px',
  },
  [up('md')]: {
    gap: '12px',
  },
  [up('lg')]: {
    gap: '13px',
  },
  [up('xl')]: {
    gap: '14px',
  },
  [up('xxl')]: {
    gap: '15px',
  },
});
export const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  color: '#fff',
}));

export const ConvertCurrencyTypo = styled(Typography)(() => ({
  cursor: 'pointer',
  textDecoration: 'underline',
  [up('xs')]: {
    fontSize: '8px',
  },
  [up('sm')]: {
    fontSize: '8px',
  },
  [up('md')]: {
    fontSize: '10px',
  },
  [up('lg')]: {
    fontSize: '12px',
  },
  [up('xl')]: {
    fontSize: '13px',
  },
  [up('xxl')]: {
    fontSize: '14px',
  },
}));

export const AddIconContainerBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
});

export const InputRemoveButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.lunarBase.lighter,
  color: theme.palette.lunarBase.main,
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: theme.palette.lunarBase.lighter,
    color: theme.palette.lunarBase.main,
  },
  width: '49%',
}));

export const ValidateButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.secondaryWhite.main,
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondaryWhite.main,
  },
  width: '49%',
  height: '40px',
}));

export const ValidationMessageTypo = styled(Typography)(() => ({
  color: '#FF0000',
}));
export const ValidationTypoWithMB = styled(Typography)(() => ({
  color: '#FF0000',
  marginBottom: '10px',
}));

export const VersionActionButtonsContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const InputPopupCloseIconContainer = styled(Box)({
  width: '24px',
  height: '24px',
});

export const InputButtonIconsContainer = styled(Box)({
  marginRight: '5px',
});

export const IconButtonContainer = styled(IconButton)({
  position: 'absolute',
  right: 2,
  top: 2,
});

export const ProductGrid = styled(Grid)({
  marginBottom: '10px',
});

export const AddIconBox = styled(Box)({
  marginRight: '8px',
  [up('xs')]: {
    height: '10px',
    width: '10px',
  },
  [up('sm')]: {
    height: '12px',
    width: '12px',
  },
  [up('md')]: {
    height: '14px',
    width: '14px',
  },
  [up('lg')]: {
    height: '16px',
    width: '16px',
  },
  [up('xl')]: {
    height: '18px',
    width: '18px',
  },
  [up('xxl')]: {
    height: '20px',
    width: '20px',
  },
});

export const LoaderBox = styled(Box)({
  padding: '26px 40px 26px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const InputButtonContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
});

export const DataFieldDropdownContainer = styled(Box)({
  margin: '0 auto 10px',
  width: '100%',
});

export const PreviewCropImageTypoBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '32px',
  marginBottom: '10px',
});

export const PreviewCropImageMainBox = styled(Box)(({ theme }) => ({
  padding: '10px',
  borderRadius: '4px',
  border: `1px solid ${theme.palette.primary.medium}`,
  height: '80px',
  maxHeight: '130px',
  overflow: 'auto',
  '&::-webkit-scrollbar': {
    width: '5px',
    height: '5px',
    borderRadius: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: theme.palette.lynxWhite.lightest,
    borderRadius: '8px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: theme.palette.secondaryBlack.lighter,
    borderRadius: '8px',
  },
}));

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {},
  [`& .${classes.invoiceGridMainBox}`]: {
    background: 'rgba(255, 255, 255, 1)',
    overflow: 'auto',
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: '0.4em',
    },
    '&::-webkit-scrollbar-track': {
      background: '#D9D9D9',
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#868686',
      borderRadius: '5px',
    },
    [up('xs')]: {
      height: `calc(100vh - ${theme.spacing(6)});`,
    },
  },
  [`& .${classes.invoicePdfBox}`]: {
    border: '1px solid gray',
    overflow: 'auto',
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: '0.4em',
    },
    '&::-webkit-scrollbar-track': {
      background: '#D9D9D9',
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#868686',
      borderRadius: '5px',
    },
    '&.react-multi-carousel-list': {
      width: '100%',
    },
    [up('xs')]: {
      height: `calc(100vh - ${theme.spacing(6)} - ${theme.spacing(6)});`,
    },
  },
  [`& .${classes.arrowDownIconWithTransition}`]: {
    transform: 'rotate(180deg)',
    transition: 'transform  0.3s ease',
  },
  [`& .${classes.arrowDownIconWithoutTransition}`]: {
    transform: 'none',
    transition: 'transform  0.3s ease',
  },
  [`& .${classes.stagSelectDropdownButton}`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [up('xs')]: {
      width: '80px',
      height: '30px',
      margin: '3px',
    },
    [up('sm')]: {
      width: '95px',
      height: '38px',
      margin: '4px',
    },
    [up('md')]: {
      width: '150px',
      height: '40px',
      margin: '6px',
    },
    [up('lg')]: {
      width: '150px',
      height: '44px',
      margin: '7px',
    },
    [up('xl')]: {
      width: '160px',
      height: '60px',
      margin: '9px',
    },
    [up('xxl')]: {
      width: '170px',
      height: '65px',
      margin: '12px 9px',
    },
  },
  [`& .${classes.invoiceGrid}`]: {
    borderLeft: '1px solid rgba(0, 0, 0, 0.06)',
    background: theme.palette.lynxWhite.main,
    overflow: 'auto',
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: '0.4em',
    },
    '&::-webkit-scrollbar-track': {
      background: '#D9D9D9',
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#868686',
      borderRadius: '5px',
    },
    // [up('xs')]: {
    //   height: `calc(100vh - ${theme.spacing(6)});`,
    // },
  },
  [`& .${classes.invoiceGridInnerBox}`]: {
    overflow: 'auto',
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: '0.4em',
    },
    '&::-webkit-scrollbar-track': {
      background: '#D9D9D9',
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#868686',
      borderRadius: '5px',
    },
    [up('xs')]: {
      height: `calc(100vh - ${theme.spacing(6)} - 130px);`,
    },
    [up('sm')]: {
      height: `calc(100vh - ${theme.spacing(6)} - 135px);`,
    },
    [up('md')]: {
      height: `calc(100vh - ${theme.spacing(6)} - 130px);`,
    },
    [up('lg')]: {
      height: `calc(100vh - ${theme.spacing(6)} - 152px);`,
    },
    [up('xl')]: {
      height: `calc(100vh - ${theme.spacing(6)} - 162px);`,
    },
    [up('xxl')]: {
      height: `calc(100vh - ${theme.spacing(6)} - 172px);`,
    },
  },
  // [`& .${classes.invoiceGridBox}, &.css-1plut9a.root`]: {
  //   height: '100% !important',
  // },
  [`& .${classes.invoiceGridBox}`]: {
    // height: '100%',
    // '&.css-1plut9a.root': {
    //   height: '100% !important',
    // },
    [up('xs')]: {
      margin: '9px 10px',
    },
    [up('sm')]: {
      margin: '10px 11px',
    },
    [up('md')]: {
      margin: '11px 12px',
    },
    [up('lg')]: {
      margin: '14px 13px',
    },
    [up('xl')]: {
      margin: '12px 11px',
    },
    [up('xxl')]: {
      margin: '20px 14px',
    },
  },
  [`& .${classes.invoiceRecordBox}`]: {
    [up('xs')]: {
      marginBottom: '16px',
    },
    [up('sm')]: {
      marginBottom: '16px',
    },
    [up('md')]: {
      marginBottom: '16px',
    },
    [up('lg')]: {
      marginBottom: '16px',
    },
    [up('xl')]: {
      marginBottom: '16px',
    },
    [up('xxl')]: {
      marginBottom: '25px',
    },
  },
  [`& .${classes.confirmDocumentButtonContainer}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0px 20px 0px 20px',
    gap: '30px',
  },
  [`& .${classes.invoiceRecordTitle}`]: {
    color: theme.palette.dynamicBlack.semiDark,
    [up('xs')]: {
      paddingLeft: '10px',
    },
    [up('sm')]: {
      paddingLeft: '12px',
    },
    [up('md')]: {
      paddingLeft: '12px',
    },
    [up('lg')]: {
      paddingLeft: '16px',
    },
    [up('xl')]: {
      paddingLeft: '20px',
    },
    [up('xxl')]: {
      paddingLeft: '23px',
    },
  },
  [`& .${classes.validateBtn}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: theme.palette.primary.main,
    color: 'white',
    width: '100%',
    ':hover': {
      background: theme.palette.primary.main,
      color: 'white',
    },
    [up('xs')]: {
      height: '30px',
    },
    [up('sm')]: {
      height: '34px',
    },
    [up('md')]: {
      height: '36px',
    },
    [up('lg')]: {
      height: '40px',
    },
    [up('xl')]: {
      height: '44px',
    },
    [up('xxl')]: {
      height: '50px',
    },
  },
  [`& .${classes.trashBtn}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: theme.palette.lunarBase.lighter,
    borderRadius: '5px',
    [up('xs')]: {
      width: '35px',
      height: '35px',
    },
    [up('sm')]: {
      width: '40px',
      height: '40px',
    },
    [up('md')]: {
      width: '35px',
      height: '35px',
    },
    [up('lg')]: {
      width: '45px',
      height: '45px',
    },
    [up('xl')]: {
      width: '47px',
      height: '47px',
    },
    [up('xxl')]: {
      width: '54px',
      height: '54px',
    },
  },
  [`& .${classes.checkCircleIcon}`]: {
    marginRight: '14px',
    height: '18px',
    width: '18px',
  },
  [`& .${classes.gridContainer}`]: {
    borderRadius: '5px',
    [up('xs')]: {
      padding: '4px',
    },
    [up('sm')]: {
      padding: '5px',
    },
    [up('md')]: {
      padding: '4px',
    },
    [up('lg')]: {
      padding: '5px',
    },
    [up('xl')]: {
      padding: '6px',
    },
    [up('xxl')]: {
      padding: '8px',
    },
  },
  [`& .${classes.gridContainerBackgroundColor}`]: {
    background: theme.palette.primary.lighter,
  },
  [`& .${classes.gridContainerBackgroundHoverColor}`]: {
    '&:hover': {
      background: theme.palette.primary.lighter,
    },
  },
  [`& .${classes.checkedFieldIcon}`]: {
    [up('xs')]: {
      width: '11px',
      height: '11px',
    },
    [up('sm')]: {
      width: '12px',
      height: '12px',
    },
    [up('md')]: {
      width: '13px',
      height: '13px',
    },
    [up('lg')]: {
      width: '14px',
      height: '14px',
    },
    [up('xl')]: {
      width: '15px',
      height: '15px',
    },
    [up('xxl')]: {
      width: '16px',
      height: '16px',
    },
  },
  [`& .${classes.fiberManualRecordIcon}`]: {
    color: theme.palette.lunarBase.main,
    [up('xs')]: {
      width: '7px',
      height: '7px',
    },
    [up('sm')]: {
      width: '8px',
      height: '8px',
    },
    [up('md')]: {
      width: '7px',
      height: '7px',
    },
    [up('lg')]: {
      width: '8px',
      height: '8px',
    },
    [up('xl')]: {
      width: '9px',
      height: '9px',
    },
    [up('xxl')]: {
      width: '10px',
      height: '10px',
    },
  },
  [`& .${classes.contentEditableField}`]: {
    border: 'none',
    outline: 'none',
    cursor: 'pointer',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: theme.palette.primary.main,
  },
  [`& .${classes.typographyField}`]: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  [`& .${classes.gridAlign}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  [`& .${classes.checkCloseIcon}`]: {
    cursor: 'pointer',
    [up('xs')]: {
      width: '15px',
      height: '15px',
    },
    [up('sm')]: {
      width: '17px',
      height: '17px',
    },
    [up('md')]: {
      width: '14px',
      height: '14px',
    },
    [up('lg')]: {
      width: '17px',
      height: '17px',
    },
    [up('xl')]: {
      width: '19px',
      height: '19px',
    },
    [up('xxl')]: {
      width: '22px',
      height: '22px',
    },
  },
  [`& .${classes.CardComponent}`]: {
    backgroundColor: lightPalette.secondaryWhite.main,
    borderRadius: '5px',
    overflow: 'auto',
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: '0.4em',
    },
    '&::-webkit-scrollbar-track': {
      background: '#D9D9D9',
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#868686',
      borderRadius: '5px',
    },

    [up('xs')]: {
      width: '250px',
      height: '280px',
    },
    [up('sm')]: {
      width: '440px',
      height: '350px',
    },
    [up('md')]: {
      width: '510px',
      height: '395px',
    },
    [up('lg')]: {
      width: '640px',
      height: '463px',
    },
    [up('xl')]: {
      width: '740px',
      height: '550px',
    },
    [up('xxl')]: {
      width: '880px',
      height: '640px',
    },
  },
  [`& .${classes.closeAction}`]: {
    '& .css-1pqm26d-MuiAvatar-img': {
      cursor: 'pointer',
    },
    [up('xs')]: {
      width: '20px',
      height: '20px',
    },
    [up('sm')]: {
      width: '18px',
      height: '18px',
    },
    [up('md')]: {
      width: '19px',
      height: '19px',
    },
    [up('lg')]: {
      width: '23px',
      height: '23px',
    },
    [up('xl')]: {
      width: '24px',
      height: '24px',
    },
    [up('xxl')]: {
      width: '30px',
      height: '30px',
    },
  },
  [`& .${classes.ConfirmDocumentCheckCircleIcon}`]: {
    [up('xs')]: {
      width: '20px',
      height: '20px',
    },
    [up('sm')]: {
      width: '25px',
      height: '25px',
      marginBottom: '8px',
    },
    [up('md')]: {
      width: '28px',
      height: '28px',
      marginBottom: '10px',
    },
    [up('lg')]: {
      width: '34px',
      height: '34px',
      margin: '8px 0 11px',
    },
    [up('xl')]: {
      width: '40px',
      height: '40px',
      margin: '7px 0 12px',
    },
    [up('xxl')]: {
      width: '47px',
      height: '47px',
      margin: '20px 0 12px',
    },
  },
  [`& .${classes.previousVersion}`]: {
    color: lightPalette.lunarBase.main,
    fontWeight: 100,
    [up('xs')]: {
      height: '22px',
    },
    [up('sm')]: {
      height: '25px',
      marginLeft: '11px',
    },
    [up('md')]: {
      height: '28px',
      marginLeft: '13px',
    },
    [up('lg')]: {
      height: '23px',
      marginLeft: '15px',
    },
    [up('xl')]: {
      height: '24px',
    },
    [up('xxl')]: {
      height: '25px',
      marginLeft: '17px',
    },
  },
  [`& .${classes.cardHeader}`]: {
    width: '100%',
    [up('xs')]: {
      height: '90px',
    },
    [up('sm')]: {
      height: '85px',
      padding: '0 12px',
    },
    [up('md')]: {
      height: '100px',
      padding: '0 16px',
    },
    [up('lg')]: {
      height: '120px',
      padding: '0 16px',
      marginBottom: '3px',
    },
    [up('xl')]: {
      height: '145px',
      padding: '0 16px',
      marginBottom: '5px',
    },
    [up('xxl')]: {
      height: '160px',
      padding: '0 16px',
      marginBottom: '10px',
    },
  },
  [`& .${classes.CardContent}`]: {
    width: '100%',
    [up('xs')]: {
      padding: '6px',
      height: '240px',
    },
    [up('sm')]: {
      padding: '9px',
      height: '260px',
    },
    [up('md')]: {
      padding: '8px 14px',
      height: '290px',
    },
    [up('lg')]: {
      padding: '9px 18px',
      height: '330px',
    },
    [up('xl')]: {
      padding: '10px 22px',
      height: '400px',
    },
    [up('xxl')]: {
      padding: '15px 30px',
      height: '460px',
    },
  },
  [`& .${classes.moreHeight}`]: {
    height: '100%',
  },
  [`& .${classes.PreviousVersionBox}`]: {
    border: '1px solid rgba(43, 30, 89, 0.2)',
    borderRadius: '5px',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
    width: '100%',
    [up('xs')]: {
      height: '85px',
      marginBottom: '7px',
    },
    [up('sm')]: {
      height: '70px',
      marginBottom: '13px',
    },
    [up('md')]: {
      height: '72px',
      marginBottom: '14px',
    },
    [up('lg')]: {
      height: '90px',
      marginBottom: '18px',
    },
    [up('xl')]: {
      height: '100px',
      marginBottom: '22px',
    },
    [up('xxl')]: {
      height: '120px',
      marginBottom: '26px',
    },
  },
  [`& .${classes.VersionAutoCompleteBox}`]: {
    border: '1px solid rgba(43, 30, 89, 0.2)',
    borderRadius: '5px',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
    width: '100%',
    [up('xs')]: {
      height: '85px',
      marginBottom: '7px',
    },
    [up('sm')]: {
      height: '85px',
      marginBottom: '5px',
    },
    [up('md')]: {
      height: '95px',
      marginBottom: '12px',
    },
    [up('lg')]: {
      height: '120px',
      marginBottom: '18px',
    },
    [up('xl')]: {
      height: '125px',
      marginBottom: '24px',
    },
    [up('xxl')]: {
      height: '150px',
      marginBottom: '24px',
    },
  },
  [`& .${classes.gridItemAutoComplete}`]: {
    display: 'flex',
    justifyContent: 'center',
    borderRadius: '5px',
    width: '96%',
    margin: '0 auto',
    '& .MuiInputBase-input': {
      [up('xs')]: {
        height: '6px',
      },
      [up('sm')]: {
        height: '13px',
      },
      [up('md')]: {
        height: '20px',
      },
      [up('lg')]: {
        height: '27px',
      },
      [up('xl')]: {
        height: '30px',
      },
      [up('xxl')]: {
        height: '45px',
      },
    },
  },

  [`& .${classes.gridItems}`]: {
    height: '100%',
    width: '100%',
  },
  [`& .${classes.gridItemsTypography}`]: {
    [up('xs')]: {
      paddingBottom: '3px',
    },
    [up('sm')]: {
      margin: '17px 11px 5px',
    },
    [up('md')]: {
      margin: '15px 13px 5px',
    },
    [up('lg')]: {
      margin: '20px 15px 6px',
    },
    [up('xl')]: {
      margin: '20px 15px 6px',
    },
    [up('xxl')]: {
      margin: '24px 17px 6px',
    },
  },
  [`& .${classes.ConfirmDocumentButtonsBox}`]: {
    width: '100%',
    [up('xs')]: {
      height: '45px',
    },
    [up('sm')]: {
      height: '80px',
    },
    [up('md')]: {
      height: '90px',
    },
    [up('lg')]: {
      height: '67px',
    },
    [up('xl')]: {
      height: '92px',
    },
    [up('xxl')]: {
      height: '110px',
    },
  },
  [`& .${classes.SaveChangesButtons}`]: {
    [up('xs')]: {
      width: '80px',
      height: '30px',
      margin: '3px',
    },
    [up('sm')]: {
      width: '95px',
      height: '38px',
      margin: '4px',
    },
    [up('md')]: {
      width: '110px',
      height: '40px',
      margin: '6px',
    },
    [up('lg')]: {
      width: '110px',
      height: '44px',
      margin: '7px',
    },
    [up('xl')]: {
      width: '160px',
      height: '60px',
      margin: '9px',
    },
    [up('xxl')]: {
      width: '170px',
      height: '65px',
      margin: '12px 9px',
    },
  },
  [`& .${classes.editModeCheckIcon}`]: {
    color: theme.palette.primary.main,
  },
  [`& .${classes.validateCheckIcon}`]: {
    color: theme.palette.colorGreen.main,
  },
  [`& .${classes.loaderBox}`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [up('xs')]: {
      height: '60vh',
    },
    [up('sm')]: {
      height: '70vh',
    },
    [up('md')]: {
      height: '60vh',
    },
    [up('lg')]: {
      height: '65vh',
    },
    [up('xl')]: {
      height: '70vh',
    },
    [up('xxl')]: {
      height: '80vh',
    },
  },
  [`& .${classes.cursorDefaultClass}`]: {
    cursor: 'default',
  },
  [`& .${classes.cursorDisableClass}`]: {
    cursor: 'not-allowed',
  },
  [`& .${classes.sidebarTypographyColor}`]: {
    color: theme.palette.lunarBase.main,
  },
  [`& .${classes.noBoundingBoxColor}`]: {
    color: theme.palette.orange.main,
  },
  [`& .${classes.noBoundingBoxTypography}`]: {
    color: theme.palette.orange.main,
    [up('xs')]: {
      marginLeft: theme.spacing(2.5),
    },
    [up('sm')]: {
      marginLeft: theme.spacing(3),
    },
    [up('md')]: {
      marginLeft: theme.spacing(2.5),
    },
    [up('lg')]: {
      marginLeft: theme.spacing(3),
    },
    [up('xl')]: {
      marginLeft: theme.spacing(3.5),
    },
    [up('xxl')]: {
      marginLeft: theme.spacing(4.5),
    },
  },
  [`& .${classes.dialogBoxClass}`]: {
    width: '540px',
    borderRadius: '5px',
    boxShadow: '0px 0px 11px 4px rgba(0, 0, 0, 0.08)',
    backgroundColor: 'rgba(255, 255, 255, 1)',
    p: '40px 40px 26px',
    display: 'flex',
    flexDirection: 'column',
  },
  [`& .${classes.subNavbar}`]: {
    background: theme.palette.pastelLavender.main,
    [up('xs')]: {
      height: `${theme.spacing(6)}`,
    },
  },
  [`& .${classes.subNavbarToolbar}`]: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.subNavbarToolbar}`]: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.subNavbarToolbarJustifyContentConditionalSpaceBetween}`]: {
    justifyContent: 'space-between',
  },
  [`& .${classes.subNavbarToolbarJustifyContentFlexEnd}`]: {
    justifyContent: 'flex-end',
  },
  [`& .${classes.versionSelect}`]: {
    width: '200px',
    marginRight: '2vw',
    [up('sm')]: {
      height: '26px',
    },
    [up('md')]: {
      height: '30px',
    },
    [up('lg')]: {
      height: '33px',
    },
    [up('xl')]: {
      height: '35px',
    },
    [up('xxl')]: {
      height: '40px',
    },
  },
  [`& .${classes.selectVersionHelperText}`]: {
    color: lightPalette.colorRed.main,
    margin: '3px 0 0 9px',
  },
  [`& .${classes.editField}`]: {
    padding: 0,
    marginRight: '1vw',
    '& .MuiInputBase-inputMultiline': {
      '&::-webkit-scrollbar': {
        display: 'none', // For Chrome, Safari, and Opera
      },
      '-ms-overflow-style': 'none', // For Internet Explorer and Edge
      scrollbarWidth: 'none', // For Firefox
    },
    '& fieldset': {
      border: 'none',
    },
    '& .MuiInputBase-input:hover + fieldset': {
      border: 'none !important',
    },
    '& .MuiInputBase-input:focus + fieldset': {
      border: 'none !important',
    },
    '& .css-ffi4rr-MuiInputBase-input-MuiOutlinedInput-input': {
      padding: 0,
    },
  },
  [`& .${classes.inputGrid}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    margin: 'auto',
    height: '100%',
  },
  [`& .${classes.datePickerTextField}`]: {
    width: '100%',
    marginBottom: '10px',
  },
  [`& .${classes.newHeight}`]: {
    height: '100%',
  },
  [`& .${classes.invoicePdfBoxNewHeight}`]: {
    [up('xs')]: {
      height: `calc(100vh - ${theme.spacing(6)} - ${theme.spacing(6)} - 204px);`,
    },
  },
  [`& .${classes.rootGridContainer}`]: {
    height: 'calc(100vh - 34px)',
    padding: '16px 16px 6px',
  },
  [`& .${classes.invoiceGridNewHeight}`]: {
    height: '30%',
    marginLeft: '16px',
    borderRadius: '8px',
  },
  [`& .${classes.firstRow}`]: {
    height: '70%',
  },
  [`& .${classes.documentEditCellBox}`]: {
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.editCellTextfield}`]: {
    '& fieldset': {
      border: 'none',
      borderRadius: '5px',
      backgroundColor: theme.palette.secondaryWhite.semiDark,
    },
    '& .MuiInputBase-input:hover + fieldset': {
      border: 'none !important',
    },
    '& .MuiInputBase-input:focus + fieldset': {
      border: 'none !important',
    },
    [up('xs')]: {
      width: '18vw',
    },
    [up('sm')]: {
      width: '45vw',
    },
    [up('md')]: {
      width: '34vw',
    },
    [up('lg')]: {
      width: '24vw',
    },
    [up('xl')]: {
      width: '23vw',
    },
    [up('xxl')]: {
      width: '18vw',
    },
  },
  [`& .${classes.editCellActionIcons}`]: {
    padding: '0px, 10px',
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.editIcon}`]: {
    cursor: 'pointer',
    fontSize: '10px',
    [up('xs')]: {
      width: '12px',
      height: '12px',
    },
    [up('sm')]: {
      width: '14px',
      height: '14px',
    },
    [up('md')]: {
      width: '16px',
      height: '16px',
    },
    [up('lg')]: {
      width: '10px',
      height: '10px',
    },
    [up('xl')]: {
      width: '20px',
      height: '20px',
    },
    [up('xxl')]: {
      width: '22px',
      height: '22px',
    },
  },
  [`& .${classes.transactinGrid}`]: {
    height: '100%',
    '& .css-1plut9a.root': {
      height: '100%', // Override or apply styles if needed
    },
  },
  [`& .${classes.transactionGridSection}`]: {
    padding: '0px 20px',
  },
  [`& .${classes.deleteButton}`]: {
    backgroundColor: 'rgba(43, 30, 89, 0.2)',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    [up('xs')]: {
      width: '35px',
      height: '30px',
    },
    [up('sm')]: {
      width: '39px',
      height: '34px',
    },
    [up('md')]: {
      width: '41px',
      height: '36px',
    },
    [up('lg')]: {
      width: '45px',
      height: '40px',
    },
    [up('xl')]: {
      width: '49px',
      height: '44px',
    },
    [up('xxl')]: {
      width: '55px',
      height: '50px',
    },
  },
  [`& .${classes.pagination}`]: {
    display: 'flex',
    gap: '15px',
    alignItems: 'center',
  },
  [`& .${classes.arrowButton}`]: {
    color: `${lightPalette.secondaryBlack.main}`,
    height: '20px',
    width: '20px',
    cursor: 'pointer',
    '&:hover': {
      color: '#ffff',
    },
  },
  [`& .${classes.arrowHoverButton}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '30px',
    height: '30px',
    '&:hover': {
      backgroundColor: 'rgba(159,119,235, 1)',
      borderRadius: '50%',
    },
  },
  [`& .${classes.blankDiv}`]: {
    width: '30px',
    height: '30px',
  },
}));
